import { render, staticRenderFns } from "./orderStatementForm.vue?vue&type=template&id=19ec2376&"
import script from "./orderStatementForm.vue?vue&type=script&lang=ts&"
export * from "./orderStatementForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports